export const theme = {
  color: {
    first: '#FEFEFE',
    second: '#1561AD',
    third: '#57B6B5',
    fourth: '#FC5226',
  },
  font: {
    size: {
      xxs: '1rem',
      xs: '1.2rem',
      s: '1.4rem',
      sm: '2rem',
      m: '2.6rem',
      ml: '3.4rem',
      l: '5.2rem',
      xl: '7.2rem',
      xxl: '9.4rem',
    },
    family: {
      open: `Open Sans, sans-serif`,
      raleway: `'Raleway', sans-serif`,
      alex: `'Alex Brush', cursive`,
    },
    weight: {
      light: '300',
      medium: '400',
      bold: '700',
    },
  },
  mq: {
    tablet: `@media (min-width:768px)`,
    desktop: `@media (min-width:1024px)`,
    big: `@media (min-width:1440px)`,
    low: `@media (max-height:645px)`,
    height: `@media (min-height:750px)`,
  },
};
